import { ThemeUICSSObject } from 'theme-ui';

// Pins the modal layer to the viewport and centres the panel on both axes, so a
// panel stays put while the page behind it scrolls. Mirrors `modalContainerStyle`
// in VendorReceiving, minus its `pointerEvents: 'none'`: the backdrop below is a
// child of this element and its click is the fullscreen viewer's dismiss.
//
// `zIndex` is load-bearing, and has to beat every layer this can open over, not
// just the ones nearby. `position: fixed` opens a stacking context whatever its
// z-index, so the backdrop's 100 and the panel's 101 only order each other from
// here on and the whole layer stacks at this one value. `CustomModal` renders
// before the routed page (App.tsx), so on a tie the page's layer paints on top:
// a value merely equal to a sibling loses. The layers it can meet, all of them
// in the root stacking context because no ancestor of theirs opens one, are the
// date picker's calendar (101), the overflow menu's portal (120) and the
// dropdown portal (150). 200 clears all three and reuses the tier the app
// already gives overlays rather than inventing a number.
export const container: ThemeUICSSObject = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 200,
};

export const backdrop: ThemeUICSSObject = {
  position: 'fixed',
  width: '100%',
  height: '100%',
  background: 'black',
  opacity: '0.25',
  zIndex: '100',
};

export const styledConfirmationModal: ThemeUICSSObject = {
  // `relative`, not `static`: the container centres this panel, but the panel is
  // still the containing block its absolutely positioned children expect.
  position: 'relative',
  maxWidth: '350px',
  background: 'white',
  borderRadius: '16px',
  zIndex: '101',
  padding: '24px 22px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

export const styledFullscreenModal: ThemeUICSSObject = {
  // Containing block for `exitButtonWrapper`; see `styledConfirmationModal`.
  position: 'relative',
  display: 'flex',
  background: 'white',
  borderRadius: '12px',
  zIndex: '101',
  margin: '20px',
  height: '90%',
  width: '95%',
  justifyContent: 'center',
  alignItems: 'center',
};

export const exitButtonWrapper: ThemeUICSSObject = {
  position: 'absolute',
  right: '38px',
  top: '38px',
  cursor: 'pointer',
  height: '30px',
  padding: 0,
  border: 0,
  background: 'transparent',
};

export const messageStyle: ThemeUICSSObject = {
  fontFamily: 'body',
  fontSize: 2,
  color: 'black',
  textAlign: 'center',
};

export const buttonContainer: ThemeUICSSObject = {
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  marginTop: '24px',
};

export const image: ThemeUICSSObject = {
  display: 'flex',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
};
